import React from "react";
import Modal from "../ui/Modal";

interface SelectModalProps {
  title: string;
  message: string;
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (option: string) => void;
  options: string[];
}

export default function SelectModal({ title, message, isOpen, onClose, options, onConfirm }: SelectModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-4">
        <p className="text-gray-700">{message}</p>
        <div className="grid grid-cols-2 gap-2">
          {options.map((option) => (
            <button
              key={option}
              className="w-full px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm"
              onClick={() => onConfirm(option)}>
              {option} Gün
            </button>
          ))}
        </div>

        <div className="flex gap-3 justify-end pt-4 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm">
            İptal
          </button>
        </div>
      </div>
    </Modal>
  );
}
